// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-decor[data-v-2eae6b88]{background-repeat:no-repeat;background-size:cover;background-position:50%;margin:0 -50px;padding:0 50px;width:calc(100vw + 100px)}.shape[data-v-2eae6b88]{-webkit-clip-path:ellipse(900px 900px at 50% calc(100% - 900px));clip-path:ellipse(900px 900px at 50% calc(100% - 900px))}", ""]);
// Exports
module.exports = exports;
